module.exports = __webpack_public_path__ + "prod/1.42.2/img/icon-success.c0c9386d.svg";